export const FETCH_CURRENCY_SUCCESS = 'FETCH_CURRENCY_SUCCESS';
export const SET_CURRENCY = 'SET_CURRENCY';
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
export const CLOSE_FORM_ERROR = 'CLOSE_FORM_ERROR';
